var map = {
	"./q1_option1_1.png": 78035,
	"./q1_option1_2.png": 32280,
	"./q1_option2_1.png": 23172,
	"./q1_option2_2.png": 77823,
	"./q1_option3_1.png": 37813,
	"./q1_option3_2.png": 52062,
	"./q1_option4_1.png": 19494,
	"./q1_option4_2.png": 17053,
	"./q1_option5_1.png": 47991,
	"./q1_option5_2.png": 63708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26683;